export default "__VITE_PUBLIC_ASSET__dc825be4__"